import { SVGProps, Ref, forwardRef } from 'react';

export const LocationFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.666 2.35 3.548 4.543C1.488 5.427.458 5.868.501 6.538c.045.67 1.124.973 3.283 1.577l3.204.897.897 3.204c.604 2.159.906 3.238 1.577 3.283s1.111-.987 1.995-3.047l2.193-5.118c1.583-3.695 2.375-5.542 1.466-6.45-.908-.909-2.755-.117-6.45 1.466"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LocationFilledSize16Glyph.displayName = 'LocationFilledSize16Glyph';
